import { fromJS, Map } from 'immutable';

import {
  SHOW_ALERT_NOTIFICATION
} from './constants';

const initialState = fromJS({
  alert: {
    show: false,
    props: {}
  }
});

const NotifyAlertReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_ALERT_NOTIFICATION:
      return state
        .set('alert', Map(action.data));
    default:
      return state;
  }
};

export default NotifyAlertReducer;
